module.exports = __webpack_public_path__ + "static/media/aeronave.5e3ecad8.glb";